<template>
  <div
    class="relative h-full w-full min-h-0 overflow-hidden"
    :class="isImageRounded"
    @mouseenter="show"
    @mouseleave="hide"
  >
    <div class="relative flex h-full w-full min-h-0 items-center justify-center">
      <a
        v-show="!isLoading"
        :download="file.filename"
        :href="path"
        class="h-full w-full"
        @click.prevent.stop="onImgClick"
      >
        <img
          v-touch.stop="onImgClick"
          :src="path"
          :alt="file.filename"
          data-test="file-image"
          class="h-full w-full object-cover"
          @load="onImageLoad"
        >
      </a>
      <wui-icon
        v-show="isLoading"
        name="spinner"
        class="self-center"
      />
    </div>

    <div
      v-show="hover"
      class="
        absolute left-0 top-0 h-full w-full cursor-pointer
        bg-linear-to-b from-black to-transparent opacity-25
      "
      @click.stop="onImgClick"
    />

    <div
      v-show="hover"
      class="absolute right-3 top-3"
    >
      <a
        class="inline-block cursor-pointer"
        :href="getFullURL(`/files/${file.filecookie}`)"
        :download="file.filename"
        :title="file.filename"
        data-test="file-link"
        @contextmenu.stop
      >
        <wui-btn
          icon
          variant="neut"
          state="alpha"
          prepend-icon="save"
          :size="32"
        />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { WuiIcon, WuiBtn } from '@wui/common-library'
import { IMFile } from '@wui/im'
import { computed, ref } from 'vue'

import { useHover } from '@/shared/composables/use-hover'
import { vTouch } from '@/shared/directives/v-touch'
import {
  isChatImagePreviewCached,
  markChatImagePreviewCached,
} from '@/shared/utils/files'
import { getFullURL } from '@/shared/utils/url'

const props = defineProps<{
  file: IMFile,
  isRounded?: boolean,
}>()

const emits = defineEmits(['img-click', 'loaded'])

const { hover, show, hide } = useHover()
const isLoading = ref(!isChatImagePreviewCached(props.file.filecookie))

const onImageLoad = () => {
  markChatImagePreviewCached(props.file.filecookie)
  isLoading.value = false
  emits('loaded')
}
const onImgClick = () => {
  emits('img-click', props.file)
}

const path = computed(() => {
  return getFullURL(`/files/${props.file.filecookie}`)
})

const isImageRounded = computed(() => {
  return props.isRounded ? 'rounded-12' : ''
})
</script>
